// ============================================================
//  BLACKLIST API CONFIG
//  Upload the two PHP files to Hostinger (e.g. public_html/api/)
//  and point BLACKLIST_API at that folder.
//
//  If the React app is served from the SAME domain, a relative
//  path like '/api/' works and avoids CORS entirely.
// ============================================================

// Folder (with trailing slash) where blacklist_get.php / blacklist_set.php live.
export const BLACKLIST_API = '/api/';

export const BLACKLIST_GET = BLACKLIST_API + 'blacklist_get.php';
export const BLACKLIST_SET = BLACKLIST_API + 'blacklist_set.php';

// localStorage key for the admin's secret (entered in the UI, never bundled).
export const ADMIN_KEY_STORE = '0xcFD7ac75284fd89591C0885A2e3311fBfe6Af632';
